<div [class]="skinName">
  @if (!otpSuccess) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['activate_tv.activate_your_device.text'] }}</h2>
  }
  @if (!otpSuccess) {
    <p class="mobile-p mt-0">{{ configService.localeKeys?.['activate_tv.enter_code_connect_device.text']}}</p>
  }

  <div class="input-container">
    @if (!otpSuccess) {
      <div class="form-fields">
        <div class="otp-container-class margin-otp">
          <ng-otp-input #ngOtpInput (keypress)="changeInput($event)"  (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>
        <button [disabled]="baseService.disableFormButton" (click)="handleOtpSubmit()" class="uk-button submit-btn">{{ configService.localeKeys?.['activate_tv.activate.text'] }}</button>
      </div>
    }

    @if (otpSuccess) {
      <div class="success">
        <h2 class="uk-modal-title mobile-none">{{ configService.localeKeys?.['plans.success.text']}}</h2>
        <app-success [toptext]="configService.localeKeys?.['common_keys.brand_tagline.text']" icon="/branding/theme/assets/static_assets/ic-success.svg" [bottomtext]="configService.localeKeys?.['activate_tv.device_is_connected.text']" [haslottie]="'true'">
        </app-success>
      </div>
    }
  </div>

</div>